import { render, staticRenderFns } from "./ContactActionsComponent.vue?vue&type=template&id=5fd933ca"
import script from "./ContactActionsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactActionsComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd933ca')) {
      api.createRecord('5fd933ca', component.options)
    } else {
      api.reload('5fd933ca', component.options)
    }
    module.hot.accept("./ContactActionsComponent.vue?vue&type=template&id=5fd933ca", function () {
      api.rerender('5fd933ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactActions/ContactActionsComponent.vue"
export default component.exports